import { createServerFn } from '@tanstack/react-start';
import { getCookie, getRequest, setResponseStatus } from '@tanstack/react-start/server';
import { z } from 'zod';
import { A2UI_GALLERY_SIDEBAR_COOKIE } from './a2ui/gallery/A2UIWorkbenchSidebar';
import { A2UI_PREVIEW_LOCALE_COOKIE } from './a2ui/preview/a2uiPreviewCopy';
import { resolveA2UIRouteData } from './a2ui/serverData';

export const loadA2UIRouteData = createServerFn({ method: 'GET' })
  .inputValidator(z.string().min(1))
  .handler(async ({ data: pathname }): Promise<any> => {
    const routeData = await resolveA2UIRouteData({
      pathname,
      transferHeader: getRequest().headers.get('x-a2ui-preview-transfer'),
      cookieValues: {
        [A2UI_GALLERY_SIDEBAR_COOKIE]: getCookie(A2UI_GALLERY_SIDEBAR_COOKIE),
        [A2UI_PREVIEW_LOCALE_COOKIE]: getCookie(A2UI_PREVIEW_LOCALE_COOKIE),
      },
    }); // This server function is the only browser-callable route-data boundary. Keep all cookie/header-sensitive behavior behind it so client loaders cannot drift from direct SSR requests.
    if (routeData.kind === 'not-found') setResponseStatus(routeData.status);
    if (routeData.kind === 'redirect') setResponseStatus(routeData.status);
    return routeData;
  });
